import { USER_AGENT_STRING } from "./constants";

// DEFUALT APP_API_VERSION IF NOT PROVIDED IN URL OBJECT
const DEFAULT_API_VERSION = 52;

// NEXT_PUBLIC_ENV
const v2BaseUrl = "https://api-v2.classplusapp.com";
const urlObject = {
  PROD: {
    BASE_URL: "https://api.classplusapp.com",
    API_GRAPH_URL: "https://api.classplusapp.com/cams/graph-api",
  },
  QA: {
    BASE_URL: "https://apip-qa.classplusapp.com",
    API_GRAPH_URL: "https://apip-qa.classplusapp.com/cams/graph-api",
  },
  PREPROD: {
    BASE_URL: "https://apip-preprod.classplusapp.com",
    API_GRAPH_URL: "https://apip-preprod.classplusapp.com/cams/graph-api",
  },
  STAGING: {
    BASE_URL: "https://apip-staging.classplusapp.com",
    API_GRAPH_URL: "https://apip-staging.classplusapp.com/cams/graph-api",
  },
};

// REFRESH ACCESS TOKEN API ENDPOINTS
const refreshTokenEndpoints = {
  url: () => "/users/refreshAccessToken",
  method: "POST",
};

// FUNCTION TO GET API BASE URL AND API VERSION
const getApiBaseURL = () => {
  return urlObject[process.env.REACT_APP_ENV || "PREPROD"]?.BASE_URL;
};

export const getApiGraphUrl = () => {
  return urlObject[process.env.REACT_APP_ENV || "PREPROD"]?.API_GRAPH_URL;
};

const getApiVersion = () => {
  return (
    urlObject[process.env.REACT_APP_ENV || "PREPROD"]?.API_VERSION ||
    DEFAULT_API_VERSION
  );
};

// FETCHING USER TOKEN FROM URL
export const getUserToken = () => {
  const userTokenQueryParam =
    typeof window !== "undefined"
      ? new URLSearchParams(window?.location?.search).get("token")
      : "";
  const userTokenLocalStorage =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("userToken")
      : "";

  const userTokenRefreshed =
    typeof window !== "undefined" ? window.refreshedToken : "";


  // ASSIGNING USER TOKEN BASED ON PRIORITY
  const userToken =
    userTokenRefreshed ||
    userTokenQueryParam ||
    userTokenLocalStorage;

  // RETURNING USER TOKEN
  return userToken;
};

export const isAPKQueryParam =
    typeof window !== "undefined"
      ? new URLSearchParams(window?.location?.search).get("is_apk")
      : "";

export const getRegion = () => {
  const countryCodeParam =
    typeof window !== "undefined"
      ? new URLSearchParams(window?.location?.search).get("region")
      : "";
  const countryCodeLocalStorage =
    typeof localStorage !== "undefined" ? localStorage.getItem("region") : "";

  // RETURNING USER TOKEN BASED ON PRIORITY
  const countryCode =
    countryCodeParam ||
    countryCodeParam ||
    countryCodeLocalStorage ||
    "IN";

  return countryCode;
};

// FUNCTION TO GET DEVICE TYPE FROM NAVIGATOR
export const getUserAgent = () => {
  if (typeof window === "undefined") {
    return "server-render";
  }
  return /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    typeof window !== "undefined" && window?.navigator.userAgent
  )
    ? USER_AGENT_STRING.ANDROID
    : USER_AGENT_STRING.IOS;
};

// FUNCTION TO GET MOBILE-AGENT (aditional header for device specific checks)
export const getMobileAgent = (url) => {
  // IF URL IS NOT OF STORE (i.e. doesn't contains /v2/course)
  if (!url || (!url.includes("v2/course") && !url.includes("v3/course")))
  {
    if(!url.includes("mm/v3")) {
      return {}
    }
  }

  // IF SERVER SIDE
  if (typeof window === "undefined") return {};

  // GETTING DEVICE TYPE FROM NAVIGATOR
  if (getUserAgent()) {
    return {
      "mobile-agent": getUserAgent(),
    };
  }

  // ELSE RETURN EMPTY OBJECT (unknown case)
  return {};
};

// FUNCTION TO GET ACCEPT-LANGUAGE
export const getDefaultLanguage = () => {
  // FETCHING ALL DEFAULT LANG STORED
  const defaultLanguageQueryParam =
    typeof window !== "undefined"
      ? new URLSearchParams(window?.location?.search).get("defaultLanguage")
      : "";
  const defaultLanguageLocalStorage =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("defaultLanguage")
      : "";

  // ASSIGNING USER TOKEN BASED ON PRIORITY
  const defaultLanguage =
    defaultLanguageQueryParam ||
    defaultLanguageLocalStorage;

  // RETURNING USER TOKEN
  return defaultLanguage;
};

// FUNCTION TO GET API HEADERS
export const getHeaders = (customToken, region, defaultLanguage) => {
  return {
    "x-access-token": customToken || getUserToken(),
    "Api-Version": getApiVersion(),
    "is-apk": isAPKQueryParam || 0,
    "accept-language":
      defaultLanguage?.toLowerCase() || getDefaultLanguage()?.toLowerCase(),
    region: region || getRegion(),
    // "App-Version": getAppVersion(),
    ...(typeof window === "undefined"
      ? { "User-Agent": USER_AGENT_STRING.ANDROID }
      : {}),
  };
};

// DEFAULT AXIOS CONFIG FOR API CALLS
const getAxiosConfig = (
  method,
  urlCallback,
  payload,
  customToken,
  region,
  defaultLanguage,
  extraHeaders,
  isV2 = false
) => {
  return {
    method: method, // API METHOD ex. GET POST PATCH
    url: `${
      isV2 && process?.env?.REACT_APP_ENV == "PROD"
        ? v2BaseUrl
        : getApiBaseURL()
    }${urlCallback(payload)}`, // PASSING WHOLE PAYLOAD OBJECT IN URL CALLBACK (DESTRUCT IN ENDPOINTS)
    ...(method === "GET" ? {} : { data: payload }), // PAYLOAD DATA
    headers: {
      ...extraHeaders,
      ...getHeaders(customToken, region, defaultLanguage),
      ...getMobileAgent(urlCallback(payload)),
    }, // API HEADERS // CUSTOM TOKEN IF DON'T WANT TO USE USER TOKEN
  };
};

export default getAxiosConfig;
